import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const SummaryText = styled(Typography)({
  fontFamily: 'inherit',
  whiteSpace: 'pre-wrap'
});
